import React, { useState } from 'react';
import { api } from './api';

// First thing after sign-in until the user has their own SnapTrade keys.
// Left: the two fields. Right: the three steps to get them.
export default function Setup({ onDone }) {
  const [clientId, setClientId] = useState('');
  const [consumerKey, setConsumerKey] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const save = async e => {
    e.preventDefault();
    setBusy(true); setError('');
    try { onDone(await api('/me/snaptrade', { method: 'PUT', body: { client_id: clientId, consumer_key: consumerKey } })); }
    catch (err) { setError(err.message); setBusy(false); }
  };

  return (
    <section className="df-setup">
      <form className="df-setup-form" onSubmit={save} autoComplete="off">
        <h2>connect snaptrade</h2>
        <p className="df-muted">your brokers link through your own free SnapTrade account. paste its two keys once.</p>
        <label>
          <span>client id</span>
          <input value={clientId} onChange={e => setClientId(e.target.value)} placeholder="PERS-XXXXXXXXXXXXXXXXXXXX" spellCheck="false" autoFocus />
        </label>
        <label>
          <span>consumer key</span>
          <input type="password" value={consumerKey} onChange={e => setConsumerKey(e.target.value)} placeholder="••••••••••••••••" />
        </label>
        {error && <p className="df-error">{error}</p>}
        <button className="df-btn" type="submit" disabled={!clientId.trim() || !consumerKey.trim() || busy}>
          {busy ? 'checking with snaptrade…' : 'save & continue'}
        </button>
        <p className="df-muted df-fine">stored encrypted on our server. we read holdings only — never trade, never see your broker password.</p>
      </form>

      <ol className="df-steps">
        <li>
          <b>create a free SnapTrade account</b>
          <span><a href="https://dashboard.snaptrade.com" target="_blank" rel="noreferrer">dashboard.snaptrade.com</a> → sign up. email + password, no card. skip anything about Claude or ChatGPT.</span>
        </li>
        <li>
          <b>copy your API keys</b>
          <span><a href="https://dashboard.snaptrade.com" target="_blank" rel="noreferrer">dashboard</a> → <em>API keys</em>. copy <em>Client ID</em> (starts with <code>PERS-</code>) and <em>Consumer Key</em>. the key is shown once — if it's hidden, regenerate it.</span>
        </li>
        <li>
          <b>paste them here, then link a broker</b>
          <span>after saving you'll pick Fidelity or E*TRADE and sign in on the broker's own site, with your usual 2FA. once.</span>
        </li>
      </ol>
    </section>
  );
}
